/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MatchQuestion } from '../../models/match-question';

export interface CreateMatchCompetencyQuestion$Params {
      body?: MatchQuestion
}

export function createMatchCompetencyQuestion(http: HttpClient, rootUrl: string, params?: CreateMatchCompetencyQuestion$Params, context?: HttpContext): Observable<StrictHttpResponse<MatchQuestion>> {
  const rb = new RequestBuilder(rootUrl, createMatchCompetencyQuestion.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MatchQuestion>;
    })
  );
}

createMatchCompetencyQuestion.PATH = '/matchquestion';
